import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "להודות בפחד, בלי להתבייש",
    opening: localizedGenderNode(
      [
      "היום אני לא דוחף את עצמי להתחיל. אני מודה: יש בי פחד."
    ],
      [
      "היום אני לא דוחף את עצמי להתחיל. אני מודה: יש בי פחד."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת איטית.",
      "אני אומר לעצמי בלב: “הפחד הזה מנסה לשמור עליי.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת איטית.",
      "אני אומר לעצמי בלב: “הפחד הזה מנסה לשמור עליי.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה בדיוק מפחיד אותי במחשבה על דייט/היכרות חדשה?\n[כאן אני כותב]",
      "איזו מחשבה חוזרת כשאני מדמיין/ת התחלה?\n[כאן אני כותב]",
      "איפה בגוף אני מרגיש/ה את הפחד הזה?\n[כאן אני כותב]"
    ],
      [
      "מה בדיוק מפחיד אותי במחשבה על דייט/היכרות חדשה?\n[כאן אני כותב]",
      "איזו מחשבה חוזרת כשאני מדמיין/ת התחלה?\n[כאן אני כותב]",
      "איפה בגוף אני מרגיש/ה את הפחד הזה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "פחד הוא לא כישלון. הוא אות."
    ],
      [
      "סגירה",
      "פחד הוא לא כישלון. הוא אות."
    ]
    ),
    action: localizedGenderNode(
      "כשעולה מחשבה על דייט — נשימה אחת + “כרגע אני רק מקשיב/ה”.",
      "כשעולה מחשבה על דייט — נשימה אחת + “כרגע אני רק מקשיב/ה”."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "מה אני מפחד/ת שיראו בי",
    opening: localizedGenderNode(
      [
      "היום אני נוגע/ת בפחד מהחשיפה."
    ],
      [
      "היום אני נוגע/ת בפחד מהחשיפה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני מפחד/ת שיגלו עליי בדייט?\n[כאן אני כותב]",
      "איזו תכונה בי מרגישה “לא מספיק”?\n[כאן אני כותב]",
      "מי לימד אותי שאפשר להסתיר את זה?\n[כאן אני כותב]"
    ],
      [
      "מה אני מפחד/ת שיגלו עליי בדייט?\n[כאן אני כותב]",
      "איזו תכונה בי מרגישה “לא מספיק”?\n[כאן אני כותב]",
      "מי לימד אותי שאפשר להסתיר את זה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "הפחד להיחשף נולד פעם כדי להגן."
    ],
      [
      "סגירה",
      "הפחד להיחשף נולד פעם כדי להגן."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב/ת תכונה אחת שאני רגיל/ה להסתיר — בלי לשפוט.",
      "אני כותב/ת תכונה אחת שאני רגיל/ה להסתיר — בלי לשפוט."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "לחץ להיות “משהו”",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת את הלחץ להופיע מושלם."
    ],
      [
      "היום אני בודק/ת את הלחץ להופיע מושלם."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה תפקיד אני מרגיש/ה שאני בוחר/ת/ה לשחק בדייט?\n[כאן אני כותב]",
      "מה יקרה אם לא אשחק אותו?\n[כאן אני כותב]",
      "איך הגוף שלי מגיב לרעיון של “להרשים”?\n[כאן אני כותב]"
    ],
      [
      "איזה תפקיד אני מרגיש/ה שאני בוחר/ת/ה לשחק בדייט?\n[כאן אני כותב]",
      "מה יקרה אם לא אשחק אותו?\n[כאן אני כותב]",
      "איך הגוף שלי מגיב לרעיון של “להרשים”?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "קשר לא מתחיל מהופעה. הוא מתחיל מנוכחות."
    ],
      [
      "סגירה",
      "קשר לא מתחיל מהופעה. הוא מתחיל מנוכחות."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום — אני שם לב מתי אני “מתאמץ/ת להיות”.",
      "פעם אחת היום — אני שם לב מתי אני “מתאמץ/ת להיות”."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "זיכרונות מדייטים קודמים",
    opening: localizedGenderNode(
      [
      "היום אני מפריד/ה בין עבר להווה."
    ],
      [
      "היום אני מפריד/ה בין עבר להווה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזו חוויה מהעבר עדיין יושבת לי על הגוף?\n[כאן אני כותב]",
      "מה אני מפחד/ת שיקרה שוב?\n[כאן אני כותב]",
      "מה שונה בי היום לעומת אז?\n[כאן אני כותב]"
    ],
      [
      "איזו חוויה מהעבר עדיין יושבת לי על הגוף?\n[כאן אני כותב]",
      "מה אני מפחד/ת שיקרה שוב?\n[כאן אני כותב]",
      "מה שונה בי היום לעומת אז?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "העבר מסביר — הוא לא מנהל."
    ],
      [
      "סגירה",
      "העבר מסביר — הוא לא מנהל."
    ]
    ),
    action: localizedGenderNode(
      "אני אומר/ת לעצמי: “זה זיכרון, לא נבואה.”",
      "אני אומר/ת לעצמי: “זה זיכרון, לא נבואה.”"
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "פחד מדחייה",
    opening: localizedGenderNode(
      [
      "היום אני נוגע/ת בפחד שיגידו “לא”."
    ],
      [
      "היום אני נוגע/ת בפחד שיגידו “לא”."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה בשבילי דחייה אומרת עליי?\n[כאן אני כותב]",
      "איפה למדתי שדחייה = משהו לא בסדר בי?\n[כאן אני כותב]",
      "מה האמת העדינה יותר?\n[כאן אני כותב]"
    ],
      [
      "מה בשבילי דחייה אומרת עליי?\n[כאן אני כותב]",
      "איפה למדתי שדחייה = משהו לא בסדר בי?\n[כאן אני כותב]",
      "מה האמת העדינה יותר?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "דחייה לא מגדירה ערך."
    ],
      [
      "סגירה",
      "דחייה לא מגדירה ערך."
    ]
    ),
    action: localizedGenderNode(
      "כשעולה פחד — יד על חזה + נשימה.",
      "כשעולה פחד — יד על חזה + נשימה."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "הגוף והדייט",
    opening: localizedGenderNode(
      [
      "היום אני מקשיב/ה לגוף, לא נלחם בו."
    ],
      [
      "היום אני מקשיב/ה לגוף, לא נלחם בו."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת איטית."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת איטית."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הגוף שלי עושה כשאני מדמיין/ת דייט?\n[כאן אני כותב]",
      "איזו תחושה הכי חזקה?\n[כאן אני כותב]",
      "מה הגוף בוחר/ת ממני עכשיו?\n[כאן אני כותב]"
    ],
      [
      "מה הגוף שלי עושה כשאני מדמיין/ת דייט?\n[כאן אני כותב]",
      "איזו תחושה הכי חזקה?\n[כאן אני כותב]",
      "מה הגוף בוחר/ת ממני עכשיו?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "הגוף מדבר בשפה של הגנה."
    ],
      [
      "סגירה",
      "הגוף מדבר בשפה של הגנה."
    ]
    ),
    action: localizedGenderNode(
      "3 נשימות עמוקות כשעולה מתח.",
      "3 נשימות עמוקות כשעולה מתח."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "למה אני בכלל רוצה קשר",
    opening: localizedGenderNode(
      [
      "היום אני חוזר/ת לכוונה."
    ],
      [
      "היום אני חוזר/ת לכוונה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "למה אני רוצה קשר? (לא למה “בוחר/ת”)\n[כאן אני כותב]",
      "איזו תחושה אני מחפש/ת?\n[כאן אני כותב]",
      "איזו כוונה רכה אני שם/ה לעצמי?\n[כאן אני כותב]"
    ],
      [
      "למה אני רוצה קשר? (לא למה “בוחר/ת”)\n[כאן אני כותב]",
      "איזו תחושה אני מחפש/ת?\n[כאן אני כותב]",
      "איזו כוונה רכה אני שם/ה לעצמי?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "כוונה מרגיעה פחד."
    ],
      [
      "סגירה",
      "כוונה מרגיעה פחד."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב/ת כוונה אחת ושומר/ת אותה.",
      "אני כותב/ת כוונה אחת ושומר/ת אותה."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "להאט את הקצב",
    opening: localizedGenderNode(
      [
      "היום אני משחרר/ת לחץ למהר."
    ],
      [
      "היום אני משחרר/ת לחץ למהר."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מי אמר שבוחר/ת למהר?\n[כאן אני כותב]",
      "מה קורה בי כשאני מדמיין/ת קצב איטי?\n[כאן אני כותב]",
      "איזו הקלה יש בזה?\n[כאן אני כותב]"
    ],
      [
      "מי אמר שבוחר/ת למהר?\n[כאן אני כותב]",
      "מה קורה בי כשאני מדמיין/ת קצב איטי?\n[כאן אני כותב]",
      "איזו הקלה יש בזה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "קצב איטי הוא בטוח."
    ],
      [
      "סגירה",
      "קצב איטי הוא בטוח."
    ]
    ),
    action: localizedGenderNode(
      "אני מזכיר/ה לעצמי: “לאט זה מותר.”",
      "אני מזכיר/ה לעצמי: “לאט זה מותר.”"
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "גבולות בדייט",
    opening: localizedGenderNode(
      [
      "היום אני זוכר/ת שמותר לי גבול."
    ],
      [
      "היום אני זוכר/ת שמותר לי גבול."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה גבול חשוב לי בדייט?\n[כאן אני כותב]",
      "מה הפחד אם אציב אותו?\n[כאן אני כותב]",
      "איך גבול מגן עליי?\n[כאן אני כותב]"
    ],
      [
      "איזה גבול חשוב לי בדייט?\n[כאן אני כותב]",
      "מה הפחד אם אציב אותו?\n[כאן אני כותב]",
      "איך גבול מגן עליי?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "גבול יוצר ביטחון."
    ],
      [
      "סגירה",
      "גבול יוצר ביטחון."
    ]
    ),
    action: localizedGenderNode(
      "אני מנסח/ת גבול אחד לעצמי.",
      "אני מנסח/ת גבול אחד לעצמי."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "לא כל חיבור יכול להצליח",
    opening: localizedGenderNode(
      [
      "היום אני משחרר/ת את רעיון ה”גורלי”."
    ],
      [
      "היום אני משחרר/ת את רעיון ה”גורלי”."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הלחץ שלי מכל היכרות חדשה?\n[כאן אני כותב]",
      "מה יקרה אם זו רק פגישה, לא יותר?\n[כאן אני כותב]",
      "איך זה מרגיש בגוף?\n[כאן אני כותב]"
    ],
      [
      "מה הלחץ שלי מכל היכרות חדשה?\n[כאן אני כותב]",
      "מה יקרה אם זו רק פגישה, לא יותר?\n[כאן אני כותב]",
      "איך זה מרגיש בגוף?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "פגישה היא לא מבחן חיים."
    ],
      [
      "סגירה",
      "פגישה היא לא מבחן חיים."
    ]
    ),
    action: localizedGenderNode(
      "אני אומר/ת: “זו רק פגישה.”",
      "אני אומר/ת: “זו רק פגישה.”"
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "להיות אני, גם עם פחד",
    opening: localizedGenderNode(
      [
      "היום אני לא מחכה להיות אמיץ/ה."
    ],
      [
      "היום אני לא מחכה להיות אמיץ/ה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך אני נראה/ת כשאני אני?\n[כאן אני כותב]",
      "מה קורה אם הפחד שם — ואני בכל זאת אני?\n[כאן אני כותב]",
      "איזו הקלה יש בזה?\n[כאן אני כותב]"
    ],
      [
      "איך אני נראה/ת כשאני אני?\n[כאן אני כותב]",
      "מה קורה אם הפחד שם — ואני בכל זאת אני?\n[כאן אני כותב]",
      "איזו הקלה יש בזה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אומץ הוא להיות, לא להיעלם."
    ],
      [
      "סגירה",
      "אומץ הוא להיות, לא להיעלם."
    ]
    ),
    action: localizedGenderNode(
      "אני מאפשר/ת לעצמי להיות טבעי/ת.",
      "אני מאפשר/ת לעצמי להיות טבעי/ת."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "אמון הדרגתי",
    opening: localizedGenderNode(
      [
      "היום אני זוכר/ת שאמון נבנה לאט."
    ],
      [
      "היום אני זוכר/ת שאמון נבנה לאט."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה מפחיד אותי בלסמוך?\n[כאן אני כותב]",
      "מה ההבדל בין אמון מלא לאמון קטן?\n[כאן אני כותב]",
      "איזה אמון קטן אפשרי לי?\n[כאן אני כותב]"
    ],
      [
      "מה מפחיד אותי בלסמוך?\n[כאן אני כותב]",
      "מה ההבדל בין אמון מלא לאמון קטן?\n[כאן אני כותב]",
      "איזה אמון קטן אפשרי לי?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אמון לא קופץ — הוא צועד."
    ],
      [
      "סגירה",
      "אמון לא קופץ — הוא צועד."
    ]
    ),
    action: localizedGenderNode(
      "אני נותן/ת אמון קטן אחד.",
      "אני נותן/ת אמון קטן אחד."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "לבחור התקדמות עדינה",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת תנועה, לא קפיצה."
    ],
      [
      "היום אני בוחר/ת תנועה, לא קפיצה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה צעד קטן מרגיש לי אפשרי?\n[כאן אני כותב]",
      "מה הפחד סביב הצעד הזה?\n[כאן אני כותב]",
      "מה מחזק אותי בו?\n[כאן אני כותב]"
    ],
      [
      "מה צעד קטן מרגיש לי אפשרי?\n[כאן אני כותב]",
      "מה הפחד סביב הצעד הזה?\n[כאן אני כותב]",
      "מה מחזק אותי בו?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "התקדמות לא רוצהת להכאיב."
    ],
      [
      "סגירה",
      "התקדמות לא רוצהת להכאיב."
    ]
    ),
    action: localizedGenderNode(
      "אני עושה צעד קטן בלבד.",
      "אני עושה צעד קטן בלבד."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "סגירה רכה למסע",
    opening: localizedGenderNode(
      [
      "היום אני מסכם/ת בלי ללחוץ."
    ],
      [
      "היום אני מסכם/ת בלי ללחוץ."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה למדתי על הפחד שלי?\n[כאן אני כותב]",
      "מה התחזק בי?\n[כאן אני כותב]",
      "משפט חזרה לימים מלחיצים:\n[כאן אני כותב]"
    ],
      [
      "מה למדתי על הפחד שלי?\n[כאן אני כותב]",
      "מה התחזק בי?\n[כאן אני כותב]",
      "משפט חזרה לימים מלחיצים:\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה סופית למסע",
      "אני לא רוצה/ת למהר כדי להיות ראוי/ה לאהבה.",
      "אני יכול/ה לנוע בקצב שלי.",
      "עם הפחד — ועם עצמי.",
      "וזה כוח."
    ],
      [
      "סגירה סופית למסע",
      "אני לא רוצה/ת למהר כדי להיות ראוי/ה לאהבה.",
      "אני יכול/ה לנוע בקצב שלי.",
      "עם הפחד — ועם עצמי.",
      "וזה כוח."
    ]
    ),
    action: localizedGenderNode(
      "פעולה אחת שמכבדת את הקצב שלי.",
      "פעולה אחת שמכבדת את הקצב שלי."
    ),
  },
].map(buildNormalizedDay);

export const fearStartingRelationshipDatingAnxietyBlueprintHe = buildNormalizedPilotBlueprint({
  id: "fear_starting_relationship_dating_anxiety_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "fear_starting_relationship_dating_anxiety",
  category: "general",
  journeyName: {
    he: "פחד להתחיל קשר (דייטים מלחיצים)",
    en: "Fear of Starting a Relationship (Dating Anxiety)",
    es: "Miedo a Iniciar una Relación (Citas que Generan Ansiedad)",
  },
  days,
});

export default fearStartingRelationshipDatingAnxietyBlueprintHe;
